//Match title height


function MatchHeight() {
    $(".footerTopBlock .text-with-icons__item .text-custom").matchHeight();
    $(".product-card__figure").matchHeight();
    //$(".blog-post-card__info p.h3 a").matchHeight();
    $(".blog-post-card__info p.h3>p").matchHeight();
    $(".blog-post-card__info p.h3~p").matchHeight();  
    $(".text-with-icons .cst-text-icons").matchHeight();
    $(".impact-text--center .impact-text__content h3.h4").matchHeight();
    $(".product-card__info .rating-with-text .product-card__title").matchHeight();
    $(".floating-controls-container .collection-list a.collection-card.shadow").matchHeight();    
    $(".collection-card__content").matchHeight();    
}

$(document).ready(function(){

  // $('.template-blog image-link-blocks').magnificPopup({
  //   delegate: 'a', // child items selector, by clicking on it popup will open
  //   type: 'image'
  //   // other options
  // });

  $(document).on("click", '.iwish_float_wrapper .iwish-float-icon', function(event) { 
      $('body').addClass('cst-iwish-open');
  });

  $(document).on("click", '.iwish_float_wrapper .iwish-float-icon', function(event) { 
      $('body').addClass('cst-iwish-open');
  });

  $(document).on("click", '#wa .wa__btn_popup .wa__btn_popup_icon', function(event) { 
      $('body').toggleClass('cst-wa-pop-open');
  });

  $(document).on("click", 'iframe#tidio-chat-iframe', function(event) { 
      $('body').toggleClass('cst-tidio-pop-open');
  });

  

  $(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('body').addClass('custom_header');
    } else {
       $('body').removeClass('custom_header');
    }
  });    
  
  $('.template-blog image-link-blocks').magnificPopup({
  delegate: 'a', // the selector for gallery item  
  type: 'image',
  gallery:{
    enabled:true
  }
});
  
  MatchHeight();
  $('.sub-sub-link.active').parent('ul').parent('li').parent('ul').parent('div').parent('details').parent('li').addClass('active');
  
  $("input[name='contact[Phone]']").keypress(function (e) {      
  var charCode = (e.which) ? e.which : event.keyCode    
  if (String.fromCharCode(charCode).match(/[^0-9+]/g))    
      return false;                        
  });
  
});

$( window ).on("load", function() {
  MatchHeight();
});